export default __webpack_public_path__ + "static/media/GT-America-Mono-Regular.72bfafe2.woff2";